/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_EmptyInputs */

const vi_online_price_empty = /** @type {(inputs: Online_Price_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có sản phẩm nào đang bán.`)
};

/**

* @param {Online_Price_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_empty = /** @type {((inputs?: Online_Price_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_empty(inputs)
});